/**
 * Tesla Vehicle Selector – dropdown UI, no API calls.
 * Tesla = Model 3 and Model Y, years 2023–2026. Both models are selectable for every year.
 * Line properties: Make=Tesla (hidden input), Year, Model.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'teslaVehicleSelection';
  var STORAGE_TTL = 7 * 24 * 60 * 60 * 1000;
  var MODELS = ['Model 3', 'Model Y'];

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId) {
      init();
    }
  });

  function init() {
    var container = document.getElementById('tesla-vehicle-selector-block');
    if (!container) return;
    if (container.dataset.initialized === 'true') return;
    container.dataset.initialized = 'true';

    /* ── DOM refs ── */
    var selYear = document.getElementById('tesla-year');
    var selModel = document.getElementById('tesla-model');

    var validationMsg = document.getElementById('vehicle-validation-message');
    var validationFrame = null;

    /* ── Helpers ── */
    function clearSelect(selectElem, defaultText) {
      selectElem.innerHTML = '<option value="">' + defaultText + '</option>';
      selectElem.disabled = true;
    }

    function populateSelect(selectElem, options, defaultText) {
      clearSelect(selectElem, defaultText);
      options.forEach(function(opt) {
        var o = document.createElement('option');
        o.value = opt;
        o.textContent = opt;
        selectElem.appendChild(o);
      });
      selectElem.disabled = false;
    }

    /* ── Change Handlers ── */
    function handleYearChange() {
      clearSelect(selModel, 'Select Model');
      if (selYear.value) {
        populateSelect(selModel, MODELS, 'Select Model');
      }
      validateAndSyncSteps();
    }

    /* ── Validation & Stepper ── */
    function isVehicleDone() {
      return !!(selYear.value && selModel.value);
    }

    function isConfigurationComplete() {
      var colorPicker = document.querySelector('.product-color-picker');
      var setupPicker = document.querySelector('.product-setup-picker');
      var colorSelected = colorPicker ? colorPicker.querySelector('input:checked') : true;
      var setupSelected = setupPicker ? setupPicker.querySelector('input:checked') : true;

      return isVehicleDone() && colorSelected && setupSelected;
    }

    function runValidateAndSyncSteps() {
      var isComplete = isConfigurationComplete();
      var vehicleDone = isVehicleDone();

      var colorPicker = document.querySelector('.product-color-picker');
      var colorSelected = colorPicker ? colorPicker.querySelector('input:checked') : true;

      var step1 = document.getElementById('step-1-container');
      var step2 = document.getElementById('step-2-container');
      var step3 = document.getElementById('step-3-container');

      if (vehicleDone) {
        if (step1) step1.classList.add('completed');
        if (step2) step2.classList.add('active');
        if (validationMsg) validationMsg.style.display = 'none';
      } else {
        if (step1) step1.classList.remove('completed');
        if (step2) step2.classList.remove('active');
        if (step3) step3.classList.remove('active');
        if (validationMsg && selYear.value) validationMsg.style.display = 'block';
      }

      if (vehicleDone && colorSelected) {
        if (step2) step2.classList.add('completed');
        if (step3) step3.classList.add('active');
      } else {
        if (step2) step2.classList.remove('completed');
        if (step3) step3.classList.remove('active');
      }

      if (isComplete) {
        if (step3) step3.classList.add('completed');
      } else {
        if (step3) step3.classList.remove('completed');
      }

      /* ATC button gating */
      var atcButtons = document.querySelectorAll('.m-add-to-cart');
      Array.prototype.forEach.call(atcButtons, function (btn) {
        if (isComplete) {
          btn.setAttribute('data-steps-complete', 'true');
          btn.style.opacity = '1';
        } else {
          btn.setAttribute('data-steps-complete', 'false');
          btn.style.opacity = '0.7';
        }
      });

      if (vehicleDone) { saveSelection(); } else { clearStorage(); }
    }

    function validateAndSyncSteps() {
      if (validationFrame) return;
      validationFrame = requestAnimationFrame(function () {
        validationFrame = null;
        runValidateAndSyncSteps();
      });
    }

    /* ── Storage: LocalStorage + 7-day TTL ── */
    function saveSelection() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          year: selYear.value,
          model: selModel.value,
          ts: Date.now()
        }));
      } catch (e) { }
    }

    function loadSelection() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (Date.now() - data.ts > STORAGE_TTL) {
          localStorage.removeItem(STORAGE_KEY);
          return null;
        }
        return data;
      } catch (e) { return null; }
    }

    function clearStorage() {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    }

    function restoreSelection() {
      var saved = loadSelection();
      if (!saved || !saved.year) return;

      /* Only restore values that still exist in the lists (older saves used "Model 3 Highland" etc.) */
      var yearOk = Array.prototype.some.call(selYear.options, function (o) { return o.value === saved.year; });
      if (!yearOk) return;

      selYear.value = saved.year;
      handleYearChange();

      var savedModel = String(saved.model || '');
      var model = MODELS.filter(function (m) { return savedModel === m || savedModel.indexOf(m + ' ') === 0; })[0];
      if (model) {
        selModel.value = model;
      }

      validateAndSyncSteps();
    }

    /* ── Events ── */
    selYear.addEventListener('change', handleYearChange);
    selModel.addEventListener('change', validateAndSyncSteps);

    document.addEventListener('change', function (e) {
      if (e.target.closest('.product-color-picker') || e.target.closest('.product-setup-picker')) {
        validateAndSyncSteps();
      }
    });

    document.addEventListener('click', function (e) {
      var atcBtn = e.target.closest('.m-add-to-cart');
      if (atcBtn) {
        var isComplete = atcBtn.getAttribute('data-steps-complete') === 'true' || isConfigurationComplete();
        if (!isComplete) {
          var stepper = document.querySelector('.vehicle-config-stepper');
          if (stepper) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            var offset = 120;
            var elementPosition = stepper.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - offset;
            window.scrollTo({
              top: offsetPosition,
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }
        }
      }
    }, true);

    /* ── Init ── */
    restoreSelection();
    setTimeout(function () { validateAndSyncSteps(); }, 500);

    /* Listen for variant changes from theme */
    if (window.MinimogEvents) {
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, function () {
        validateAndSyncSteps();
      });
    } else {
      document.addEventListener('variant:changed', function () {
        validateAndSyncSteps();
      });
    }
  }
})();
